import { useState } from 'react'
import { FaCaretDown, FaCaretUp } from 'react-icons/fa'
import cn from 'classnames'
import s from '../../HelpCenterModal.scss'

const HelpfulHints = ({ downloadLink, thumbnailUrl, text }) => {
  const [isCollapsed, setIsCollapsed] = useState(false)

  return (
    <div className={s.rightSide}>
      <div className={s.hintsContainer}>
        <h3 className={s.title}>
          Help Center Helpful Hints
          {isCollapsed ? (
            <FaCaretDown onClick={() => setIsCollapsed(false)} />
          ) : (
            <FaCaretUp onClick={() => setIsCollapsed(true)} />
          )}
        </h3>
        {!isCollapsed && (
          <div className={s.hintsText}>
            You can pause the video and execute the steps in the system at any time.
            <br />
            <br />
            Re-size the window from the bottom right dotted corner.
            <br />
            <br />
            Drag this window on screen by clicking on the top bar and dragging.
            <br />
            <br />
            Close this window from the ‘x’ icon.
            <br />
            <br />
            Open this window again by clicking Help Center on the top main navigation.
            <br />
            <br />
          </div>
        )}
      </div>
      <h3 className={s.title}>
        <a href={downloadLink} target="_blank" rel="noopener noreferrer">
          Downloads
        </a>
      </h3>
      <div className={s.downloadsContainer}>
        <div className={s.downloadItem}>
          <a href={downloadLink} target="_blank" rel="noopener noreferrer">
            <img src={thumbnailUrl} />
          </a>
        </div>
        <div className={s.downloadItem}>
          {text}
          <a
            href={downloadLink}
            className={cn(s.saveBtn, s.btn)}
            target="_blank"
            rel="noopener noreferrer"
          >
            Download
          </a>
        </div>
      </div>
    </div>
  )
}

export default HelpfulHints
